import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import SalesStreamSummaryUserInfoDetails from './user-info';

const useStyles = makeStyles({
  summaryTitle: {
    borderBottom: '1px solid',
    borderImage: 'linear-gradient(90deg, #C722C0, #A91CED) 1',
    marginBottom: '10px',
    fontSize: '14px',
    padding: '5px',
  },
});

const SalesStreamSummaryDetails = ({ details, showMA }) => {
  const classes = useStyles();
  return (
    <Grid container style={{ marginTop: '5px' }}>
      {details &&
        details.pricers &&
        Object.entries(details.pricers).map(([item, values], index) => (
          <Fragment key={item}>
            {index === 0 && (
              <Grid item xs={12} className={classes.summaryTitle}>
                Pricing Analyst
              </Grid>
            )}
            <SalesStreamSummaryUserInfoDetails item={item} values={values} />
          </Fragment>
        ))}
      {showMA &&
        details &&
        details.markets &&
        Object.entries(details.markets).map(([item, values], index) => (
          <Fragment key={item}>
            {index === 0 && (
              <Grid item xs={12} className={classes.summaryTitle}>
                Market Analyst
              </Grid>
            )}
            <SalesStreamSummaryUserInfoDetails item={item} values={values} />
          </Fragment>
        ))}
    </Grid>
  );
};

SalesStreamSummaryDetails.propTypes = {
  details: PropTypes.object.isRequired,
  showMA: PropTypes.bool.isRequired,
};

export default SalesStreamSummaryDetails;
